document.addEventListener("DOMContentLoaded", function () {

  let animalType = "";
  let sortBy = "";

  const listingsContainer = document.getElementById("animal-listings");

  const filterButtons = document.querySelectorAll(".filter-btn");
  const sortButtons = document.querySelectorAll(".sort-btn");

  const animalTypeSelect = document.getElementById("animal-type-select");
  const sortSelect = document.getElementById("sort-select");

  function fetchAnimals() {
    if (!listingsContainer) return;

    const formData = new FormData();
    formData.append("action", "filter_animals");
    formData.append("animal_type", animalType);
    formData.append("sort_by", sortBy);

    // Fade out
    listingsContainer.classList.remove("is-visible");

    fetch(window.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        setTimeout(() => {
          listingsContainer.innerHTML = html;

          // Fade back in
          listingsContainer.classList.add("is-visible");

          // Re-apply staggered animation on each card
          const cards = listingsContainer.querySelectorAll(".stagger-card");
          cards.forEach((card, index) => {
            card.style.animation = "none";
            void card.offsetWidth; // trigger reflow
            card.style.animation = `fadeInUp 0.6s cubic-bezier(0.25, 1, 0.5, 1) forwards`;
            card.style.animationDelay = `${(index + 1) * 0.1}s`;
          });

        }, 250); // matches transition duration
      })
      .catch((error) => {
        listingsContainer.innerHTML = "<p>Error loading animals.</p>";
        console.error("AJAX error:", error);
      });
  }

  // Filter buttons
  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const isReset = btn.classList.contains("reset-btn");
      const newType = isReset ? "" : btn.dataset.animalType || "";

      if (animalType === newType) return;

      animalType = newType;

      filterButtons.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      if (isReset) {
        sortBy = "";
        sortButtons.forEach((b) => b.classList.remove("is-active"));
        if (sortSelect) sortSelect.value = "";
      }

      fetchAnimals();
    });
  });

  // Sort buttons
  sortButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const newSort = btn.dataset.sortBy || "";
      if (sortBy === newSort) return;

      sortBy = newSort;

      sortButtons.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      fetchAnimals();
    });
  });

  // Mobile selects
  if (animalTypeSelect) {
    animalTypeSelect.addEventListener("change", () => {
      const newType = animalTypeSelect.value || "";
      if (animalType === newType) return;

      animalType = newType;

      if (animalType === "") {
        sortBy = "";
        sortButtons.forEach((b) => b.classList.remove("is-active"));
        if (sortSelect) sortSelect.value = "";
      }

      fetchAnimals();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const newSort = sortSelect.value || "";
      if (sortBy === newSort) return;

      sortBy = newSort;
      fetchAnimals();
    });
  }
});
